import type { Maybe } from '@adornis/base/utilTypes.js';
import type { SchoolCacheData } from '../entity-cache/school-cache.js';

/**
 * The scope of a legacy debitor number references the school the number originates from. This resolves those scopes
 * against the school cache and labels every number with the kuerzel of its school, e.g. `MG: 12345`.
 * Numbers without a (resolvable) scope keep their plain number so they never get lost in the display.
 * @param legacyDebitorNumbers the legacy debitor numbers of a person
 * @param schools all schools, usually coming from `getAllSchools`
 */
export function buildLegacyDebitorNumberLabels(
  legacyDebitorNumbers: Maybe<ReadonlyArray<{ scope?: Maybe<string>; debitorNumber?: Maybe<string> }>>,
  schools: Maybe<ReadonlyArray<SchoolCacheData>>,
): Array<string> {
  return (legacyDebitorNumbers ?? [])
    .filter(legacyDebitorNumber => !!legacyDebitorNumber.debitorNumber)
    .map(legacyDebitorNumber => {
      const kuerzel = schools?.find(school => school._id === legacyDebitorNumber.scope)?.kuerzel;
      return kuerzel ? `${kuerzel}:${legacyDebitorNumber.debitorNumber}` : `${legacyDebitorNumber.debitorNumber}`;
    });
}
